import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkb121aRequest, Sgkb121aResponse, SGKB121AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSgkb121aService {
  /** 小売開栓結果登録結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Sgkb121aResponse>();

  /**
  * 小売開栓結果登録結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSgkb121aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB121AService} SGKB121AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSgkb121aService
   */
  constructor(
    private sGKB121AService: SGKB121AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 小売開栓結果登録API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkb121aResponse>}
   * @memberof UsedSgkb122dSgkb121aService
   */
  searchContractor(value: Sgkb121aRequest): Observable<Sgkb121aResponse> {
    // 検索条件を保存
    return this.sGKB121AService.SGKB121APost(<Sgkb121aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB121A);
          return throwError(err.message);
        })
      );
  }
}
